import dayjs from "dayjs";

class DateManipulator {
    constructor() {
        this.today = dayjs();
    }

    isDatePast = date => dayjs(date).isBefore(this.today)
}

export default new DateManipulator();